<template>
    <div>        
        <!-- Calendly inline widget begin -->
        <div ref="calendlyWidget" :data-url="calendlyUrl" style="min-width:100vw;height:100vh;"></div>
        <!-- Calendly inline widget end -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            calendlyUrl: "https://calendly.com/boolland?hide_gdpr_banner=1&primary_color=3645d3"
        }
    },
    mounted() {
        // Load Calendly widget script
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        script.onload = this.initializeCalendly;
        document.head.appendChild(script);
    },
    methods: {
        initializeCalendly() {
            if (window.Calendly) {
                window.Calendly.initInlineWidget({
                url: this.calendlyUrl,
                parentElement: this.$refs.calendlyWidget
                });
            }
        }
    }
}

</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/teaser/Calendly.vue